import React from 'react';
import { CaretUpFill } from 'react-bootstrap-icons';
import { formatDuplicateBatchError } from '../../utils/orderBatchIdentity';

/**
 * Callout when two batches on one line share a lot/batch identifier.
 * Rendered under the batch rows. The up icon points at those fields.
 *
 * @param {Object} props
 * @param {string[]} props.labels - Repeated batch numbers, first-seen spelling
 * @param {'line'|'kit component'} [props.scope]
 * @returns {JSX.Element|null}
 */
const DuplicateBatchErrorMessage = ({ labels, scope = 'line' }) => {
  const text = formatDuplicateBatchError(labels, scope);
  if (!text) return null;
  return (
    <div className="order-quantity-error-callout" role="alert">
      <span className="order-quantity-error-callout__icon" aria-hidden="true">
        <CaretUpFill />
      </span>
      <span className="order-quantity-error-callout__text">{text}</span>
    </div>
  );
};

export default DuplicateBatchErrorMessage;
